
import { computed, defineComponent, onMounted, ref } from "vue";
import { store } from "@/store/LoginDataStore";
import { View } from "@/enums";

export default defineComponent({
  setup() {
    const password = ref("");
    const passwordInputRef = ref();

    const customerId = computed(() => {
      return store.getState().customerId;
    });

    const username = computed(() => {
      return store.getState().username;
    });

    const getPasswordFromState = () => {
      const storePassword = store.getState().password;
      if (storePassword === "") {
        return;
      }

      password.value = storePassword;
    };

    const goBack = () => {
      store.setView(View.USERINFO);
    };

    const onFormSubmitted = () => {
      store.setIsLoading(true);
    };

    onMounted(() => {
      getPasswordFromState();
      passwordInputRef.value.focus();
    });

    return {
      password,
      passwordInputRef,
      customerId,
      username,
      goBack,
      onFormSubmitted,
      store,
    };
  },
});
